<div *ngIf="showBanner" [ngClass]="{
    'offline-banner': true,
    'reconnecting': state.isRequestInProgress
  }">
    <i class="fas" [ngClass]="{
      'fa-wifi-slash': !state.hasInternetAccess && !state.isRequestInProgress,
      'fa-sync-alt fa-spin': state.isRequestInProgress
    }"></i>
    <span>
        {{
        state.isRequestInProgress
        ? 'Reconnecting...'
        : 'No internet connection. Changes you make may not be saved. Please wait until you are back online.'
        }}
    </span>
</div>